/**
 * Registration vs onboarding for the classic flow screens.
 *
 * The classic screens read only localStorage.doctor_procedure, which is removed on logout and does not
 * exist on another device — so a doctor who resumed an onboarding request got the registration branch
 * (review: «failed to load», clinic info: an empty form that would create a registration draft).
 * Same rule as the new design (src/v2/screens/registration/shared.ts useFlowType): the doctor's active
 * requests decide first, the stored choice only when there is no request yet.
 */
const CLOSED = ["rejected", "cancelled", "approved"];

export function isOnboardingFlow(progress: any): boolean {
  const active = ((progress?.active_requests || []) as any[]).filter((r) => !CLOSED.includes(r.status));
  const hasOnboarding = active.some((r) => r.request_type === "onboarding");
  const hasRegistration = active.some((r) => r.request_type === "registration");
  if (hasOnboarding && !hasRegistration) return true;
  if (hasRegistration) return false;
  return localStorage.getItem("doctor_procedure") === "REGISTER_EXISTING_CLINIC";
}
